(function () {

  window.hsSpinner = {

    flagCompleted() {
      try {
        const key    = 'hs_spinner';
        const stored = JSON.parse(localStorage.getItem(key) || '{}');
        localStorage.setItem(key, JSON.stringify({ ...stored, ordered: true }));
      } catch (_) {}
    },

    addStylesheet(id, url) {
      if (document.getElementById(id)) return;
      const link = document.createElement('link');
      link.id   = id;
      link.rel  = 'stylesheet';
      link.type = 'text/css';
      link.href = url;
      document.head.appendChild(link);
    },

    init({
      containerId,
      prizesList,                 /* exactly 7 prizes, in parasol panel order (clockwise from the panel right of the top seam) */
      assets       = {},          /* { logo, parasol, beach } — beach is set via CSS, parasol/logo injected here */
      labels       = {},
      onEmailSubmit = null,       /* async (email) => {}  — newsletter / Klaviyo */
      onAddToCart   = null,       /* async (prize) => {}  — Shopify cart add (mock locally) */
      forcedPrizeKey = null,      /* set to a prize.key to always land there (testing / rigging odds) */
      revealDelay   = 2800,       /* ms the landed parasol stays visible before the prize overlay */
      idleSpin      = true,       /* slow festive spin while the email gate is open; set false to disable */
      autoOpen      = true,
      doReset       = false,
      waitForConsent = null,
      alwaysFreeProduct = false,
      campaignStart = null
    }) {

      /* ── Geometry: 7 equal panels, a seam sits at 12 o'clock, so panel
            centres are offset by half a segment. ───────────────────────── */
      const PANELS = 7;
      const SEG    = 360 / PANELS;          /* 51.4286° */
      const OFFSET = SEG / 2;               /* 25.714° — first panel centre */
      const panelCenter = (i) => OFFSET + i * SEG;

      const PRIZE_MAP = Object.fromEntries(prizesList.map((p, i) => [p.key, { ...p, index: i }]));

      /* ── Inline icons (no external font, works offline) ── */
      const ICON_CONFETTI = '<svg class="hs-spin-ico" style="color:var(--hs-pink)" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 5h2"/><path d="M5 4v2"/><path d="M11.5 4l-.5 2"/><path d="M18 5h2"/><path d="M19 4v2"/><path d="M15 9l-1 1"/><path d="M18 13l2 -.5"/><path d="M18 19h2"/><path d="M19 18v2"/><path d="M14 16.518l-6.518 -6.518l-4.39 9.58a1 1 0 0 0 1.329 1.329l9.579 -4.39z"/></svg>';
      const ICON_SPIN     = '<svg class="hs-spin-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5"/></svg>';

      let rotation   = 0;
      let isSpinning = false;
      let activePrize = null;
      let capturedEmail = '';

      /* ── LocalStorage helpers ── */
      const STORAGE_KEY = 'hs_spinner';
      if (doReset) { try { localStorage.removeItem(STORAGE_KEY); } catch (_) {} }
      const readStorage  = () => { try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {}; } catch (_) { return {}; } };
      const writeStorage = (patch) => { try { localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...readStorage(), ...patch })); } catch (_) {} };

      /* ── CSS readiness helper ──
         Calls cb() after the injected stylesheet is both downloaded and laid out.
         Falls back to rAF when the link element isn't found (e.g. CSS in <head>). */
      function runAfterCss(cb) {
        var link = document.getElementById('hs-spinner-css');
        var run  = function() { requestAnimationFrame(cb); };
        if (!link || link.sheet) { run(); return; }
        link.addEventListener('load',  run, { once: true });
        link.addEventListener('error', run, { once: true });
      }


      function addAlwaysFreeProduct() {
        if (!alwaysFreeProduct) return;
        var giftVariantId = alwaysFreeProduct.variantId;
        var quantity      = alwaysFreeProduct.quantity || 1;
        /* Delay slightly so Shopify's cart session is fully initialised */
        setTimeout(function() {
          fetch('/cart.js')
            .then(function(res) { return res.json(); })
            .then(function(cart) {
              var alreadyInCart = cart.items.some(function(item) { return item.variant_id === giftVariantId; });
              if (alreadyInCart) return;
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: giftVariantId, quantity: quantity })
              });
            })
            .then(function(res) {
              if (!res) return;
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            })
            .catch(function(err) { console.warn('[hsSpinner] addAlwaysFreeProduct failed:', err); });
        }, 800);
      }



      /* ── Reopen trigger (side tab) ── */
      function buildTriggerButton() {
        if (document.getElementById('hs-spin-trigger')) return;
        const btn = document.createElement('button');
        btn.id        = 'hs-spin-trigger';
        btn.className = 'hs-spin-trigger';
        btn.setAttribute('aria-label', labels.triggerAriaLabel || 'Open het rad');
        btn.innerHTML = labels.triggerIcon || '🏖️';
        btn.addEventListener('click', () => { writeStorage({ dismissed: false }); widget.open(); });
        document.body.appendChild(btn);
      }

      /* ── Markup ── */
      function buildMarkup(container) {
        const L = labels;
        container.innerHTML = `
          <div class="hs-spin-root" role="dialog" aria-modal="true" aria-label="${L.ariaLabel || 'HappySoaps strandrad'}">
            <div class="hs-spin-overlay" data-overlay></div>
            <div class="hs-spin-card">
              <div class="hs-spin-confetti" data-confetti></div>
              <button class="hs-spin-close" type="button" aria-label="${L.closeAriaLabel || 'Sluiten'}" data-close>×</button>
              <div class="hs-spin-inner">

                <!-- VIEW: spin -->
                <div class="hs-spin-view hs-spin-view-spin">
                  <div class="hs-spin-head">
                    ${assets.logo ? `<img class="hs-spin-logo" src="${assets.logo}" alt="HappySoaps">` : ''}
                    <div class="hs-spin-titlecard">
                      <h2 class="hs-spin-title">${L.spinTitle || 'Draai en win!'}${ICON_CONFETTI}</h2>
                      <p class="hs-spin-sub">${L.spinSubtitle || 'Draai aan de parasol voor je gratis cadeau!'}</p>
                    </div>
                  </div>

                  <div class="hs-spin-stage">
                    <div class="hs-spin-pointer" aria-hidden="true">&nbsp;</div>
                    <div class="hs-spin-wheel" data-wheel>
                      <img class="hs-spin-parasol" src="${assets.parasol}" alt="${L.parasolAlt || 'Parasol'}">
                      <div class="hs-spin-labels" data-labels></div>
                    </div>
                  </div>

                  <button class="hs-spin-primary hs-spin-spinbtn" type="button" data-spin disabled>${L.spinButton || 'Draai het rad'}${ICON_SPIN}</button>
                </div>

                <!-- VIEW: prize -->
                <div class="hs-spin-view hs-spin-view-prize">
                  ${assets.logo ? `<img class="hs-spin-logo" src="${assets.logo}" alt="HappySoaps">` : ''}
                  <h2 class="hs-spin-title">${L.prizeTitle || 'Gefeliciteerd!'}</h2>
                  <p class="hs-spin-sub">${L.prizeSubtitle || ''}</p>
                  <div class="hs-spin-prize-card" data-prize></div>
                  <button class="hs-spin-primary" type="button" data-claim>${L.claimButton || 'In winkelmandje'}</button>
                </div>

                <!-- VIEW: success -->
                <div class="hs-spin-view hs-spin-view-success">
                  <div class="hs-spin-success-icon">✓</div>
                  <h2 class="hs-spin-title">${L.successTitle || 'Toegevoegd!'}</h2>
                  <p class="hs-spin-sub">${L.successSubtitle || ''}</p>
                  <button class="hs-spin-primary" type="button" data-finish>${L.finishButton || 'Verder shoppen'}</button>
                </div>

              </div>

              <div class="hs-spin-gate" data-gate>
                <div class="hs-spin-gate-card">
                  ${(L.gateBadge && L.gateBadge.length) ? `<div class="hs-spin-badge" aria-hidden="true">${L.gateBadge.map(function (line) { var t = typeof line === 'string' ? line : (line.text || ''); var s = (line && line.size) ? line.size : 'md'; return '<span class="hs-spin-badge-' + s + '">' + t + '</span>'; }).join('')}</div>` : ''}
                  <h2 class="hs-spin-title hs-spin-gate-title">${L.spinTitle || 'Draai en win!'}${ICON_CONFETTI}</h2>
                  <p class="hs-spin-sub">${(L.gateSubtitle || 'Vul je e-mailadres in en draai aan de parasol voor een gratis cadeau bij je bestelling.').replace(/\*/g, '<span class="hs-spin-star">*</span>')}</p>
                  <input type="email" data-email placeholder="${L.emailPlaceholder || 'jouw@email.nl'}" aria-label="${L.emailAriaLabel || 'E-mailadres'}">
                  <div class="hs-spin-err" data-err></div>
                  <button class="hs-spin-primary" type="button" data-email-submit>${L.emailSubmitButton || 'Doe mee!'}</button>
                  ${L.gateNotation ? `<p class="hs-spin-note"><span class="hs-spin-star">*</span> ${L.gateNotation}</p>` : ''}
                </div>
              </div>
            </div>
          </div>`;

        if (assets.beach) container.style.setProperty('--hs-beach', `url("${assets.beach}")`);

        const root = container.querySelector('.hs-spin-root');
        renderLabels(root);
        /* Defer layout measurement until after CSS has been applied.
           When the stylesheet is injected dynamically (Shopify), clientWidth
           returns 0 if measured synchronously before the browser paints. */
        runAfterCss(function() { layoutLabels(root); });
        if (idleSpin) root.querySelector('[data-wheel]').classList.add('hs-spin-idle');
        bindEvents(root);
        return root;
      }

      /* ── Prize labels on the panels ── */
      function renderLabels(root) {
        const wrap = root.querySelector('[data-labels]');
        wrap.innerHTML = '';
        prizesList.forEach((p) => {
          const el = document.createElement('div');
          el.className = 'hs-spin-label';
          el.textContent = p.panelLabel || p.title;
          wrap.appendChild(el);
        });
      }

      function layoutLabels(root) {
        const wheel = root.querySelector('[data-wheel]');
        const size  = wheel.clientWidth || 300;
        const r     = size * 0.32;
        root.querySelectorAll('.hs-spin-label').forEach((el, i) => {
          el.style.transform = `rotate(${panelCenter(i)}deg) translateY(${-r}px)`;
        });
      }

      /* ── Confetti ──
         Pieces clean up after themselves so a burst always plays out fully and a
         new burst can layer on top without cutting the previous one off when the
         view changes. */
      function makeConfetti(root, count = 38) {
        const box = root.querySelector('[data-confetti]');
        if (!box) return;
        const colors = ['#3f6b2c', '#f4b23e', '#fc4797', '#5fa6c4', '#84a84f', '#fa9a29'];
        for (let i = 0; i < count; i++) {
          const piece = document.createElement('i');
          piece.style.left           = Math.random() * 100 + '%';
          piece.style.animationDelay = Math.random() * 0.3 + 's';
          piece.style.background     = colors[i % colors.length];
          piece.addEventListener('animationend', () => piece.remove());
          box.appendChild(piece);
        }
      }

      /* ── Spin to a panel index ── */
      function spinToIndex(root, index) {
        const wheel = root.querySelector('[data-wheel]');
        const turns = 6;
        const base  = rotation + turns * 360;
        const target = -panelCenter(index);                       /* panel centre lands under top pointer */
        const need   = (((target - base) % 360) + 360) % 360;
        rotation = base + need;
        wheel.classList.add('is-spinning');
        void wheel.offsetWidth;                                   /* force reflow so the transition starts from the current transform */
        wheel.style.transform = `rotate(${rotation}deg)`;
      }

      function renderPrize(root, prize) {
        const card = root.querySelector('[data-prize]');
        const sub  = prize.subtitle ? `<span>${prize.subtitle}</span>` : '';

        console.log("PRIZE:", prize );

        card.innerHTML = `
          ${prize.imageUrl ? `<img src="${prize.imageUrl}" alt="${prize.title}">` : ''}
          <strong>${prize.title}</strong>
          ${sub}`;
      }

      /* ── Handlers ── */

      /* Step 1: email gate — required before the wheel can be used. */
      function handleEmailGate(root) {
        const input = root.querySelector('[data-email]');
        const err   = root.querySelector('[data-err]');
        const email = (input.value || '').trim();
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
          err.textContent = labels.emailError || 'Vul een geldig e-mailadres in';
          input.focus();
          return;
        }
        err.textContent = '';
        capturedEmail = email;

        /* Capture the email — fire & forget, never blocks the UI */
        if (typeof onEmailSubmit === 'function') {
          Promise.resolve(onEmailSubmit(email)).catch(() => {});
        }

        root.querySelector('[data-wheel]').classList.remove('hs-spin-idle');  /* stop the idle spin before the real one */
        root.classList.add('email-captured');
        writeStorage({ emailCaptured: true });
        const spinBtn = root.querySelector('[data-spin]');
        if (spinBtn) spinBtn.disabled = false;
      }

      /* Step 2: spin (only reachable once the email is captured). */
      async function handleSpin(root) {
        if (isSpinning) return;
        if (!root.classList.contains('email-captured')) return;

        isSpinning = true;
        const spinBtn = root.querySelector('[data-spin]');
        spinBtn.disabled = true;

        /* Decide the prize */
        const outcome = await spinnerInterface.resolveSpin();
        activePrize = PRIZE_MAP[outcome.key] || prizesList[0];

        const wheel = root.querySelector('[data-wheel]');
        const onEnd = () => {
          wheel.removeEventListener('transitionend', onEnd);
          makeConfetti(root);
          setTimeout(() => {
            renderPrize(root, activePrize);
            writeStorage({ prizeKey: activePrize.key });
            root.classList.add('show-prize');
          }, revealDelay);
          isSpinning = false;
        };
        wheel.addEventListener('transitionend', onEnd);

        spinToIndex(root, activePrize.index);
      }

      async function handleClaim(root) {
        if (!activePrize) return;
        const btn = root.querySelector('[data-claim]');
        btn.disabled = true;
        try {
          await spinnerInterface.onWinClaimed(activePrize);
        } catch (_) {}
        writeStorage({ status: 'completed' });
        root.classList.remove('show-prize');
        root.classList.add('show-success');
        makeConfetti(root);
      }

      function closeWidget() {
        try { spinnerInterface.onClose(); } catch (_) {
          const root = document.querySelector('.hs-spin-root');
          if (root) root.remove();
          document.body.style.removeProperty('overflow');
        }
      }

      function bindEvents(root) {
        root.querySelector('[data-email-submit]').addEventListener('click', () => handleEmailGate(root));
        const emailInput = root.querySelector('[data-email]');
        emailInput.addEventListener('keydown', (e) => { if (e.key === 'Enter') handleEmailGate(root); });
        /* Clear the placeholder the moment the field is focused/clicked, restore it on blur. */
        emailInput.addEventListener('focus', () => { emailInput.dataset.ph = emailInput.getAttribute('placeholder') || ''; emailInput.setAttribute('placeholder', ''); });
        emailInput.addEventListener('blur',  () => { if (emailInput.dataset.ph != null) emailInput.setAttribute('placeholder', emailInput.dataset.ph); });
        root.querySelector('[data-spin]').addEventListener('click',  () => handleSpin(root));
        root.querySelector('[data-claim]').addEventListener('click',  () => handleClaim(root));
        root.querySelector('[data-finish]').addEventListener('click', closeWidget);
        root.querySelector('[data-close]').addEventListener('click',  closeWidget);
        root.querySelector('[data-overlay]').addEventListener('click', closeWidget);

        const onKey = (e) => { if (e.key === 'Escape') { closeWidget(); document.removeEventListener('keydown', onKey); } };
        document.addEventListener('keydown', onKey);
        window.addEventListener('resize', () => layoutLabels(root));
      }

      /* ── Widget controller ── */
      const widget = {
        open() {
          const container = document.getElementById(containerId);
          if (!container) return;
          isSpinning = false;
          activePrize = null;
          document.body.style.setProperty('overflow', 'hidden');
          const root = buildMarkup(container);

          const stored = readStorage();
          if (stored.prizeKey && stored.status !== 'completed') {
            const prize = PRIZE_MAP[stored.prizeKey];
            if (prize) {
              activePrize = prize;
              root.classList.add('email-captured');
              root.querySelector('[data-wheel]').classList.remove('hs-spin-idle');
              renderPrize(root, prize);
              root.classList.add('show-prize');
            }
          } else if (stored.emailCaptured) {
            root.classList.add('email-captured');
            const spinBtn = root.querySelector('[data-spin]');
            if (spinBtn) spinBtn.disabled = false;
            root.querySelector('[data-wheel]').classList.remove('hs-spin-idle');
          }
        }
      };



      /***
       * FOR CLAUDE — This is the spinner interface.
       * Swap the mock bodies below for the real Shopify / Klaviyo calls in production.
       * Locally these defer to the onAddToCart callback so index.html runs offline.
       */
      const spinnerInterface = {

        getState() {
          return { eligible: true };
        },

        /* Pick the winning prize. Default: random. Set forcedPrizeKey to rig it,
           or weight the random pick here to control odds for the campaign. */
        async resolveSpin() {
          if (forcedPrizeKey && PRIZE_MAP[forcedPrizeKey]) return { key: forcedPrizeKey };
          const keys = prizesList.map(p => p.key);
          return { key: keys[Math.floor(Math.random() * keys.length)] };
        },

        /* Add the won product to the cart. */
        async onWinClaimed(prize) {
          if (typeof onAddToCart === 'function') {
            return onAddToCart(prize);
          }
          /* Production Shopify version:
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: prize.variantId, quantity: 1 }] })
          });
          if (!res.ok) throw new Error('cart error');
          if (prize.discountCode) await fetch('/discount/' + encodeURIComponent(prize.discountCode)).catch(() => {});
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          */
        },

        onClose() {
          const root = document.querySelector('.hs-spin-root');
          if (root) root.remove();
          document.body.style.removeProperty('overflow');
          writeStorage({ dismissed: true });
          buildTriggerButton();
        }

      };

      /* Guard 1: customer already ordered during this campaign — hide entirely */
      try {
        var lastOrder = localStorage.getItem('hs_slotmachine_last_order');
        if (lastOrder && campaignStart && new Date(lastOrder) > new Date(campaignStart)) return;
      } catch (_) {}

      addAlwaysFreeProduct();

      /* Guard 2: dismissed or completed — show trigger only, no auto-open */
      var _stored = readStorage();
      if (_stored.dismissed || _stored.status === 'completed') {
        buildTriggerButton();
        return;
      }

      if (autoOpen) {
        if (typeof waitForConsent === 'function') {
          (function poll() {
            if (waitForConsent()) { addAlwaysFreeProduct(); widget.open(); }
            else { setTimeout(poll, 400); }
          })();
        } else {
          addAlwaysFreeProduct();
          widget.open();
        }
      } else {
        addAlwaysFreeProduct();
        buildTriggerButton();
      }
    }
  };

})();
